<template>
  <div class="success" v-if="label">
    <font-awesome-icon icon="check"/> {{label}}
  </div>
</template>

<script setup lang="ts">
interface Props {
  label?: string;
}

withDefaults(defineProps<Props>(), {
  label: 'Success!'
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.success {
  margin:20px 0;
  color: green;
}
</style>